export default __webpack_public_path__ + "static/media/et-si.5f22ddb6.svg";